import React, { useEffect, useState, useRef } from "react";
import createNewBannerTemplateIcon from "../../images/createNewBannerTemplateIcon.svg";
import MultiselectDropDown from "./MultiselectDropDown";
import SearchBannersTextfield from "./SearchBannersTextfield.js";
import DropDownButtons from "./DropDownButtons";
import { useTranslation } from "react-i18next";
import filterIcon from "../../images/FilterIcon.svg";
import FilterModal from "../BannerManager/FilterModal.js";
import { getIndicationsList, getMlrStatuses, getNewBrandsAndcampaigns, getMarketList } from "../../services/apis";
export const getBrandsFilterData = (data) => {
  return data?.map((brand) => {
    return {
      id: brand.id,
      brandName: brand.productName,
      veevaId: brand.productDamId,
    };
  });
};

const SearchSortBannerTemplate = ({
  handleFilter,
  banner,
  openNewBannerModal,
  handleCreateTempModal,
  createdByMe,
  createdByOthers,
  showSelected,
  getSearchedTemplates,
  values,
  setValues,
  setActiveButton,
  setAllCardsData,
  allCardsData,
  setCurrentPage,
  activeButton,
  getFilterDataToDisplay,
  handleMarketChange,
  setSearchText,
  searchText,
  setIsSearchBarEmpty,
  isSearchBarEmpty,
  setCanFetchMore,
  currentPage,
  selectedFilters,
  setSelectedFilters,
  initialFvalues,
  handleReset,
  createdByMeCount,
  createdByOthersCount,
  totalBannersCount,
}) => {
  const [brandsData, setBrandsData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [showFilterCount, setShowFilterCount] = useState(0);
  const firstCall = useRef(true);
  const { t } = useTranslation();
  const [mlrStatusData, setMlrStatusData] = useState([]);
  const [indicationData, setIndicationData] = useState([]);

  useEffect(() => {
    const newSelectedFilters = {
      Product: Array.isArray(values?.brand)
        ? values.brand.map((item) => item?.displayName).filter(Boolean)
        : [],
      Country: Array.isArray(values?.market)
        ? values.market.map((item) => item?.displayName).filter(Boolean)
        : [],
      "Banner Type": Array.isArray(values?.templateType)
        ? values.templateType.map((item) => item?.displayName).filter(Boolean)
        : [],
      "Content Type": Array.isArray(values?.contentType)
        ? values.contentType.map((item) => item?.displayName).filter(Boolean)
        : [],
      "MLR Status": Array.isArray(values?.mlrStatus)
        ? values.mlrStatus.map((item) => item?.displayName).filter(Boolean)
        : [],
      Indication: Array.isArray(values?.indication)
        ? values.indication.map((item) => item?.label).filter(Boolean)
        : [],
    };

    setSelectedFilters(newSelectedFilters);
    const totalCount = Object.values(newSelectedFilters).reduce(
      (sum, filterArray) =>
        sum + (Array.isArray(filterArray) ? filterArray.length : 0),
      0
    );
    setShowFilterCount(totalCount);
  }, [
    values?.brand,
    values?.market,
    values?.templateType,
    values?.contentType,
    values?.mlrStatus,
    values?.indication,
    setSelectedFilters,
  ]);
  const [search, setSearch] = useState(false);

  useEffect(() => {
    fetchBrands();
    fetchCountryData();
    fetchMlrStatusData();
    fetchIndicationData();
  }, [banner]);

  useEffect(() => {
    if (search) {
      setCurrentPage(1);
      setAllCardsData([]);
      setSearch(false);
    }
  }, [search]);

  useEffect(() => {
    if (firstCall.current) {
      firstCall.current = false;
      return;
    }
  }, []);

  useEffect(() => {
    setCanFetchMore(false);
    setCurrentPage(1);
    !firstCall.current && currentPage === 1 && getSearchedTemplates(1, "true");
  }, [values]);

  const handleFilterSync = (filterType, data) => {
    let updatedValues = { ...values };
    let updatedSelectedFilters = { ...selectedFilters };

    switch (filterType) {
      case "brand":
        updatedValues.brand = Array.isArray(data) ? data : [];
        updatedSelectedFilters.Product = Array.isArray(data)
          ? data.map((item) => item?.displayName).filter(Boolean)
          : [];
        break;
      case "market":
        updatedValues.market = Array.isArray(data) ? data : [];
        updatedSelectedFilters.Country = Array.isArray(data)
          ? data.map((item) => item?.displayName).filter(Boolean)
          : [];
        break;
      case "templateType":
        updatedValues.templateType = Array.isArray(data) ? data : [];
        updatedSelectedFilters["Banner Type"] = Array.isArray(data)
          ? data.map((item) => item?.displayName).filter(Boolean)
          : [];
        break;
      case "contentType":
        updatedValues.contentType = Array.isArray(data) ? data : [];
        updatedSelectedFilters["Content Type"] = Array.isArray(data)
          ? data.map((item) => item?.displayName).filter(Boolean)
          : [];
        break;
      case "indication":
        updatedValues.indication = Array.isArray(data) ? data : [];
        updatedSelectedFilters.Indication = Array.isArray(data)
          ? data.map((item) => item?.label).filter(Boolean)
          : [];
        break;
      case "mlrStatus":
        updatedValues.mlrStatus = Array.isArray(data) ? data : [];
        updatedSelectedFilters["MLR Status"] = Array.isArray(data)
          ? data.map((item) => item?.displayName).filter(Boolean)
          : [];
        break;
      default:
        break;
    }

    setSelectedFilters(updatedSelectedFilters);
    setValues({ ...updatedValues, canReset: true });
    handleFilter(filterType, data);
  };

  const fetchMlrStatusData = () => {
    getMlrStatuses((response, err) => {
      if (err) {
        console.error("Error fetching MLR statuses:", err);
      } else {
        const data = response.data;
        if (data && Array.isArray(data) && data.length > 0) {
          let mlrStatusData = data.map((statusString) => ({
            id: statusString,
            name: statusString,
            displayName: statusString,
            statusName: statusString,
            statusLabel: statusString,
          }));

          mlrStatusData = mlrStatusData.sort((a, b) => {
            return a.displayName.localeCompare(b.displayName, "en", {
              sensitivity: "base",
            });
          });

          setMlrStatusData(mlrStatusData);
        }
      }
    });
  };

  const fetchBrands = () => {
    getNewBrandsAndcampaigns((response, err) => {
      if (err) {
        // Handle error
      } else {
        const data = response.data;
        if (data && data.length > 0) {
          let sortedData = data.slice().sort((a, b) => {
            const brandNameA = a.brandName.trim().toUpperCase();
            const brandNameB = b.brandName.trim().toUpperCase();
            return brandNameA.localeCompare(brandNameB, "en", {
              sensitivity: "base",
            });
          });

          sortedData = [...sortedData].map((data) => {
            let object = data;
            object["displayName"] = `${object.brandName}`;
            return object;
          });

          setBrandsData(sortedData);
        }
      }
    });
  };

  const fetchCountryData = () => {
    getMarketList((response, err) => {
      if (err) {
        // Handle error
      } else {
        const data = response.data;
        if (data) {
          let marketData = data;
          if (marketData && marketData.length > 0) {
            marketData = [...marketData].map((market) => {
              let object = market;
              object["displayName"] = `${object.marketName}`;
              return object;
            });

            marketData = [...marketData].sort((marketOne, marketTwo) => {
              if (marketOne.marketName < marketTwo.marketName) {
                return -1;
              }
              if (marketOne.marketName > marketTwo.marketName) {
                return 1;
              }
              return 0;
            });

            setCountryData(marketData);
          }
        }
      }
    });
  };
  const fetchIndicationData = () => {
    getIndicationsList((response, err) => {
      if (err) {
        // Handle error
      } else {
        const data = response.data;
        if (data && data.length > 0) {
          let indicationData = data.map((indication) => ({
            ...indication,
            id: indication.name,
            displayName: indication.label,
            indicationName: indication.name,
            indicationLabel: indication.label,
          }));

          indicationData = indicationData.sort((a, b) => {
            return a.label.localeCompare(b.label, "en", {
              sensitivity: "base",
            });
          });

          setIndicationData(indicationData);
        }
      }
    });
  };

  return (
    <div className="filter-container">
      <div className="col-md-33" style={{ flex: "0 0 250px" }}>
        <DropDownButtons
          createdByMeFlag={true}
          createdByMe={createdByMe}
          createdByOthers={createdByOthers}
          showSelected={showSelected}
          banner={banner}
          setActiveButton={setActiveButton}
          setCanFetchMore={setCanFetchMore}
          setAllCardsData={setAllCardsData}
          allCardsData={allCardsData}
          setCurrentPage={setCurrentPage}
          activeButton={activeButton}
          filterDataToDisplay={getFilterDataToDisplay()}
          createdByMeCount={createdByMeCount}
          createdByOthersCount={createdByOthersCount}
          totalBannersCount={totalBannersCount}
        />
      </div>
      <div className="col-md-99" style={{ flex: "1 1 0%" }}>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <MultiselectDropDown
            title={"Product"}
            data={brandsData}
            applySelection={(data) => {
              handleFilterSync("brand", data);
            }}
            selectedFilterData={values.brand || []}
            setIsSearchBarEmpty={setIsSearchBarEmpty}
            values={values}
          />

          <MultiselectDropDown
            title={"Country"}
            data={countryData}
            applySelection={(data) => {
              handleFilterSync("market", data);
              if (data && data.length > 0) {
                handleMarketChange(data[0]);
              } else {
                handleMarketChange(null);
              }
            }}
            selectedFilterData={values.market || []}
            setIsSearchBarEmpty={setIsSearchBarEmpty}
            values={values}
          />
          <div
            className="filtersIcon"
            onClick={() => setIsFilterModalOpen(true)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={filterIcon}
              height={12}
              width={12}
              style={{ marginRight: "4px" }}
            />
            <span className="filtersLabel">Filters</span>
            {showFilterCount > 0 && (
              <span className="filtersBadge">
                {showFilterCount > 99 ? "99+" : showFilterCount}
              </span>
            )}
          </div>

          {isFilterModalOpen && (
            <FilterModal
              initialFvalues={initialFvalues}
              handleReset={handleReset}
              setShowFilterCount={setShowFilterCount}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              selectFilterLength={showFilterCount}
              isFilterModalOpen={isFilterModalOpen}
              setIsFilterModalOpen={setIsFilterModalOpen}
              brandsData={brandsData}
              countryData={countryData}
              handleFilter={handleFilterSync}
              handleMarketChange={handleMarketChange}
              values={values}
              setValues={setValues}
              mlrStatusData={mlrStatusData}
              indicationData={indicationData}
              isBanner={Boolean(banner)}
            />
          )}

          <div style={{ display: "flex", margin: "0 16px" }}>
            <SearchBannersTextfield
              style={{ width: "200px" }}
              expandable={true}
              inlineButton={true}
              search={search}
              values={values}
              onTextChange={(value) => {
                setSearchText(value);
              }}
              handleSearch={() => {
                if (searchText.trim() !== 0 || searchText.trim() !== "") {
                  setSearch(true);
                  setValues({
                    ...values,
                    templateNameInput: searchText,
                    canReset: true,
                  });
                }
              }}
              inputValue={searchText}
              setSearchText={setSearchText}
              setValues={setValues}
              setIsSearchBarEmpty={setIsSearchBarEmpty}
              isSearchBarEmpty={isSearchBarEmpty}
              placeholder={"Search by Name / ID"}
            />
          </div>

          <div
            className="create-new-button"
            onClick={banner ? openNewBannerModal : handleCreateTempModal}
          >
            <img
              src={createNewBannerTemplateIcon}
              style={{ marginRight: "6px" }}
            />
            {banner ? "Create New Banner" : "Create New Template"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchSortBannerTemplate;
